import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { getLog, getLogExport, getOversight, type LogFilter } from '../../../api/safetyRounds';
import { useChecklistLanguage } from './usePlanQueries';

export const useOversightQuery = () => useQuery({ queryKey: ['safety-rounds', 'oversight'], queryFn: getOversight });

/** The log, newest first, a page at a time */
export const useLogQuery = (filter: LogFilter) => {
  const language = useChecklistLanguage();
  return useInfiniteQuery({
    queryKey: ['safety-rounds', 'log', filter, language],
    queryFn: ({ pageParam }) => getLog(filter, language, pageParam),
    initialPageParam: null as number | null,
    getNextPageParam: (page) => page.nextBefore,
  });
};

/** All of the log in the filter, for the PDF, in the language it is made in */
export const useLogExportQuery = (filter: LogFilter, language: string) =>
  useQuery({ queryKey: ['safety-rounds', 'log', 'export', filter, language], queryFn: () => getLogExport(filter, language) });
